export const application = {
	apiKey: '001001',
	siteKey: '6LfQ4ckSAAAAAKT1X_YRwWJVyIdEzD-Zad22SaaS'
};
